export enum EDomainStatuses {
    New = 1,
    Approved = 2,
    Deleted = 3,
}
